export class LevelEditorGoalPicker extends Phaser.Group {
  /**
   * constructor
   */
  constructor() {
    super(game);

    this.fixedToCamera = true;
    this.cameraOffset.x = game.width * 0.5;
    this.cameraOffset.y = game.height * 0.5;

    this.onGoalPicked = new Phaser.Signal();

    this._makeBackgroundGraphics();
    this._makeGoalSelectBtnGroup();
    this._makeCloseButton();
  }

  /**
   * make the panel background graphics
   */
  _makeBackgroundGraphics() {
    this.add(G.Helpers.createRectangleGraphics({
      width: 650, height: 500, anchor: 0.5, color: 0x000000, alpha: 0.8, inputEnabled: true,
    }));
  }

  /**
   * make button for closing / destroying the goal picker panel
   */
  _makeCloseButton() {
    const closeBtn = this.add(new G.Text(270, -240, 'X', 'editor'));
    closeBtn.inputEnabled = true;
    closeBtn.input.useHandCursor = true;
    closeBtn.events.onInputDown.add(() => {
      this.destroy();
    });
  }

  /**
   * make all / group goal select buttons
   */
  _makeGoalSelectBtnGroup() {
    const goals = G.json['configs/gameplayGoals'];
    const btnGroup = game.make.group(this);
    Object.keys(goals).forEach((key, index) => {
      const { sprite } = goals[key];
      const btn = this._makeGoalSelectBtn(key, sprite);
      btnGroup.add(btn);
      this._setPositionFromIndex(btn, index);
    });
    btnGroup.x = Math.floor(btnGroup.width * -0.5);
    btnGroup.y = Math.floor(btnGroup.height * -0.5);
  }

  /**
   * make a goal select button
   * @param {string} key
   * @param {Phaser.Sprite} sprite
   * @returns {G.Button}
   */
  _makeGoalSelectBtn(key, sprite) {
    const btn = new G.Button(0, 0, sprite, () => {
      this.onGoalPicked.dispatch(key);
      this.destroy();
    }, this);
    return btn;
  }

  /**
   * set a goal select buttons position from its index
   * @param {G.Button} btn
   * @param {number} index
   */
  _setPositionFromIndex(btn, index) {
    const size = 80;
    const col = index % 7;
    const row = Math.floor(index / 7);
    btn.position.setTo(size * 0.5 + col * size, size * 0.5 + row * size);
  }
}
